import {
  Font,
  FontFamily,
  FontWeight,
  FontSize,
  CssVariable,
  LineHeight,
  FontStyle,
} from '@wix/css-property-parser';

export type FontParsedValue = {
  fontFamily: string | null;
  fontWeight: string | null;
  fontSize: string | null;
  lineHeight: string | null;
  fontStyle: string | null;
};

export const parseFontValue = (value: string): FontParsedValue => {
  const font = Font.parse(value);

  const values: FontParsedValue = {
    fontFamily: null,
    fontWeight: null,
    fontSize: null,
    lineHeight: null,
    fontStyle: null,
  };

  if (!font) {
    return values;
  }

  if ('type' in font && font.type === 'variable') {
    Object.keys(values).forEach((key) => {
      values[key as keyof FontParsedValue] = CssVariable.toCSSValue(font);
    });

    return values;
  }

  if ('fontFamily' in font && font.fontFamily) {
    values.fontFamily = FontFamily.toCSSValue(font.fontFamily);
  }
  if ('fontWeight' in font && font.fontWeight) {
    values.fontWeight = FontWeight.toCSSValue(font.fontWeight);
  }
  if ('fontSize' in font && font.fontSize) {
    values.fontSize = FontSize.toCSSValue(font.fontSize);
  }
  if (font.type === 'font') {
    if (font.lineHeight) {
      values.lineHeight = LineHeight.toCSSValue(font.lineHeight);
    }
    if (font.fontStyle) {
      values.fontStyle = FontStyle.toCSSValue(font.fontStyle);
    }
  }

  return values;
};
